import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import CohortWidget from './components/CohortWidget';
import SalesSectionCard from './components/SalesSectionCard';
import { COHORT_TYPE } from './constants/cohortsConfig';

const Ltv = ({ cohortsData }) => {
  return (
    <SalesSectionCard title={'LTV'}>
      <Box mt={50}>
        <CohortWidget
          cohortsData={cohortsData}
          cohortConfigKey={COHORT_TYPE.LTV}
        />
      </Box>
    </SalesSectionCard>
  );
};

Ltv.propTypes = {
  cohortsData: PropTypes.object,
};

export default Ltv;
